(function () {
  window.RegularPriceGate = {
    confirmIfNeeded: function (isRegularPrice) {
      if (!isRegularPrice) {
        return Promise.resolve(true);
      }
      var modal = document.querySelector('byob-regular-price-modal');
      if (!modal || typeof modal.openConfirm !== 'function') {
        return Promise.resolve(true);
      }
      return modal.openConfirm();
    },
  };

  class ByobRegularPriceModal extends HTMLElement {
    constructor() {
      super();
      this._resolver = null;
      this._onKeyDown = this._onKeyDown.bind(this);
    }

    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.overlay = this.querySelector('[data-byob-regular-overlay]');
      this.dialog = this.querySelector('.loa-modal__dialog');
      this.confirmBtn = this.querySelector('[data-byob-regular-confirm]');
      this.cancelBtn = this.querySelector('[data-byob-regular-cancel]');
      this.closeBtn = this.querySelector('[data-byob-regular-close]');

      if (this.confirmBtn) {
        this.confirmBtn.addEventListener('click', () => this._confirm());
      }
      if (this.cancelBtn) {
        this.cancelBtn.addEventListener('click', () => this._cancel());
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this._cancel());
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this._cancel());
      }
    }

    openConfirm() {
      return new Promise((resolve) => {
        this._resolver = resolve;
        this.hidden = false;
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this._onKeyDown);
        if (this.dialog) {
          this.dialog.focus();
        }
        if (this.confirmBtn) {
          this.confirmBtn.focus();
        }
      });
    }

    _confirm() {
      this._close(true);
    }

    _cancel() {
      this._close(false);
    }

    _close(confirmed) {
      this.hidden = true;
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', this._onKeyDown);
      var resolve = this._resolver;
      this._resolver = null;
      if (typeof resolve === 'function') resolve(!!confirmed);
    }

    _onKeyDown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this._cancel();
      }
    }
  }

  if (!customElements.get('byob-regular-price-modal')) {
    customElements.define('byob-regular-price-modal', ByobRegularPriceModal);
  }
})();
